export default {"src":"/_next/static/media/palm_40.2d8d4a49.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};